import { ActiveSportGameContext } from "contexts";
import { useParams } from "next/navigation";
import { useContext } from "react";

export const useSelectedPrematchGameId = (): number | null => {
    const params = useParams();
    const { activeGameState } = useContext(ActiveSportGameContext);
    const [, , , routeGameId] = params.prematchGameRoutes ?? [];

    return routeGameId
        ? parseInt(routeGameId)
        : params.gameId
          ? parseInt(params.gameId as string)
          : activeGameState.gameId
            ? parseInt(activeGameState.gameId)
            : null;
};
